/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import cx from 'classnames';
import * as React from 'react';
import { useMergedRefs, useTheme } from '../utils/index.js';
import '@itwin/itwinui-css/css/radio-tile.css';
/**
 * RadioTile component to be used in RadioTileGroup component
 * @example
 * <RadioTile label='My tile' description='Some info' icon={<SvgSmileyHappy />} />
 */
export const RadioTile = React.forwardRef((props, ref) => {
    const { icon, label, description, setFocus = false, className, style, ...rest } = props;
    useTheme();
    const inputElementRef = React.useRef(null);
    const refs = useMergedRefs(inputElementRef, ref);
    React.useEffect(() => {
        if (inputElementRef.current && setFocus) {
            inputElementRef.current.focus();
        }
    }, [setFocus]);
    return (React.createElement("label", { className: cx('iui-radio-tile', className), style: style },
        React.createElement("input", { className: 'iui-radio-tile-input', type: 'radio', ref: refs, ...rest }),
        React.createElement("div", { className: 'iui-radio-tile-content' },
            icon &&
                React.cloneElement(icon, {
                    className: cx('iui-radio-tile-icon', icon.props.className),
                }),
            label && React.createElement("div", { className: 'iui-radio-tile-label' }, label),
            description && (React.createElement("div", { className: 'iui-radio-tile-sublabel' }, description)))));
});
export default RadioTile;
